import util from '../util'

let controller = 'AlteracaoBoleto'
export default Object.assign({}, util.GetCrud(controller, ['post']))